import moment from 'moment-timezone';
import editShiftSuccessModal from '../edit-shift-status-modals/edit-success-modal.html';
import editShiftSuccessModalCtrl from '../edit-shift-status-modals/edit-success-modal.ctrl';
import editShiftErrorModal from '../edit-shift-status-modals/edit-error-modal.html';
import editShiftErrorModalCtrl from '../edit-shift-status-modals/edit-error-modal.ctrl';

const MIN_TIME_RANGE_HOURS = 4;
const MAX_TIME_RANGE_HOURS = 12;

class EditShiftModalController {
  /* @ngInject */
  constructor ($mdDialog, Jobs, selectedUser, shiftInfo, getCompanyJobs) {
    this.$mdDialog = $mdDialog;
    this.shiftInfo = shiftInfo;
    this.Jobs = Jobs;
    this.getCompanyJobs = getCompanyJobs;
    this.selectedUser = selectedUser;
    this.newStartTime = shiftInfo.start_time;
    this.newEndTime = shiftInfo.end_time;
    this.startTime = moment.tz(shiftInfo.start_time, shiftInfo.timezone).format('HH:mm');
    this.endTime = moment.tz(shiftInfo.end_time, shiftInfo.timezone).format('HH:mm');
    this.timeValidationError = '';
    this.fieldsEdited = false;
    this.staticProps = {
      startTime: this.startTime,
      endTime: this.endTime,
      onCancel: this.onCancel,
      onSaveChanges: this.onSaveChanges,
    };
  }

  getTime = (date) => {
    const hour = moment.tz(date, this.shiftInfo.timezone).get('hour');
    const minute = moment.tz(date, this.shiftInfo.timezone).get('minute');
    return `${hour}:${minute}`;
  }

  setFieldsEdited = () => {
    const { start_time, end_time } = this.shiftInfo;
    const startTimeChanged = this.getTime(start_time) !== this.getTime(this.newStartTime);
    const endTimeChanged = this.getTime(end_time) !== this.getTime(this.newEndTime);
    this.fieldsEdited = startTimeChanged || endTimeChanged;
  }

  onChange = (event, inputName) => {
    const { start_time, end_time } = this.shiftInfo;
    const time = event.currentTarget.value;
    const date = moment().format('YYYY-MM-DD');
    const timeToDate = moment(date + ' ' + time);

    if (inputName === 'startTime') {
      this.newStartTime = this.formatTime(start_time, timeToDate);
    } else {
      this.newEndTime = this.formatTime(end_time, timeToDate);
    }
    this.validateTime();
    this.setFieldsEdited()
  }

  calculateTimeDuration () {
    const startTime = moment.tz(this.newStartTime, this.shiftInfo.timezone);
    const endTime = moment.tz(this.newEndTime, this.shiftInfo.timezone);
    if (endTime.isBefore(startTime)) {
      endTime.add(1, 'day');
    }
    return moment.duration(endTime.diff(startTime)).asHours();
  };


  validateTime () {
    if (this.calculateTimeDuration() < MIN_TIME_RANGE_HOURS) {
      return this.timeValidationError = 'Shift duration must be greater than 4 hours';
    }
    if (this.calculateTimeDuration() > MAX_TIME_RANGE_HOURS) {
      return this.timeValidationError = 'Shift duration must be not more than 12 hours';
    }
    return this.timeValidationError = '';
  }

  showRequestStatusModal = (error) => {
    this.onCancel();
    const parentEl = document.body;
    if (error) {
      return this.$mdDialog.show({
        parent: parentEl,
        fullscreen: true,
        template: editShiftErrorModal,
        controller: editShiftErrorModalCtrl,
        controllerAs: 'e',
      });
    }
    // If success > Close current modal and show Success Modal
    const userName = this.shiftInfo.fullname
    return this.$mdDialog.show({
      parent: parentEl,
      fullscreen: true,
      template: editShiftSuccessModal,
      locals: {
        title: 'Shifts updated',
        bodyText: `You have updated 1 shift for ${userName}.`,
      },
      controller: editShiftSuccessModalCtrl,
      controllerAs: 's',
    });
  }

  formatTime = (date, time) => {
    const hour = moment(time).get('hour');
    const minute = moment(time).get('minute');
    const second = moment(time).get('second');
    const setTime = moment.tz(date, this.shiftInfo.timezone).set({ hour, minute, second });
    return setTime.tz(this.shiftInfo.timezone, true).format();
  }

  onSaveChanges = () => {
    const { start_time, end_time, timezone } = this.shiftInfo;
    const jobId = this.shiftInfo.job_id;
    const workerId = this.selectedUser[0].id;
    const addShifts = {
      startDateTime: moment(this.newStartTime).valueOf(),
      endDateTime: moment(this.newEndTime).valueOf(),
    };

    const removeShifts = {
      startDateTime: moment.tz(start_time, timezone).valueOf(),
      endDateTime: moment.tz(end_time, timezone).valueOf(),
    };
    this.Jobs.editShiftTime({
      jobId,
      removeShifts,
      addShifts,
      workerId,
    })
    .then(() => {
      this.showRequestStatusModal();
      this.getCompanyJobs();
    })
    .catch((error) => error && this.showRequestStatusModal(error));
  }

  onCancel = () => {
    this.$mdDialog.destroy();
  }
}

export default EditShiftModalController;
